/**
 * 대시보드
 */

import { customAxios } from "./customAxios";


/**
 * 노선도
 * @returns 
 */
export const getDashboardStations = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stations',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

export const getDashboardStationAlerts = async(query)=>{
  const res = await customAxios.get('/api/dashboard/stationAlerts',{params : query});
  // const res = await customAxios.get('/api/dashboard/stations:includingEquipmentFaultStatus',{params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 상태현황
 * @returns 
 */
export const getDashboardCountGroupByStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByStatus',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 설비타입별 상태현황
 * @returns 
 */
export const getDashboardCountByCategoryAndEquipmentStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countByCategoryAndEquipmentStatus',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

export const getDashboardCountGroupByMaxGrade = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByMaxGrade',{params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
* 설비별 경보현황(호선별 선그래프)-월별
* @returns 
*/
export const getDashboardCountEquipmentAlertGroupByMonth = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countEquipmentAlertGroupByMonth', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
* 설비별 경보현황(호선별 선그래프)-월별,설비대분류별별
* @returns 
*/
export const getDashboardCountEquipmentAlertGroupByMonthAndCategory1 = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countEquipmentAlertGroupByMonthAndCategory1', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비대분류별 경보현황(호선별 원그래프)
 * @returns 
 */
export const getDashboardCountEquipmentAlertGroupByEquipmentCtgr1 = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countEquipmentAlertGroupByEquipmentCtgr1', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 파트별 상태 현황
 * @returns 
 */
export const getDashboardCountGroupByStatusAndWorkingPart = async()=>{
    const res = await customAxios.get('/api/dashboard/countGroupByStatusAndWorkingPart');
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 역사별 상태 현황
 * @returns 
 */
export const getDashboardCountGroupByStatusAndStation = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByStatusAndStation',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 후속조치별 건수 현황
 * @returns 
 */
export const getDashboardCountGroupByFollowActionType = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByFollowActionType',{params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비별 경보현황(호선별 원그래프)
 * @returns 
 */
export const getDashboardCountGroupByEquipmentCtgr = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByEquipmentCtgr', {params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 설비별 경보현황(호선별 선그래프)
 * @returns 
 */
export const getDashboardCountMonthlyGroupByEquipmentCtgr = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countMonthlyGroupByEquipmentCtgr', {params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 점검필요(경보발생) 설비 목록
 * @returns 
 */
export const getDashboardEquipmentAlertsByQuery = async(query)=>{
    const res = await customAxios.get('/api/dashboard/equipmentAlerts', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/********************************** 유지보수 **********************************/

/**
 * 유지보수 점검대상(파트별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByMntStatusAndWorkingPart = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByMntStatusAndWorkingPart', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

export const getDashboardCountWorkItemsGroupByWorkingPart = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countWorkItemsGroupByWorkingPart', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

export const getDashboardCountEquipmentAlertDelayGroupByWorkingPart = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countEquipmentAlertDelayGroupByWorkingPart', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 점검대상(역사별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountEquipmentAlertDelayGroupByStation = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countEquipmentAlertDelayGroupByStation', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수 점검대상(역사별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByMntStatusAndStation = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByMntStatusAndStation', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

export const getDashboardCountWorkItemsGroupByStation = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countWorkItemsGroupByStation', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 점검대상(역사의 경보상태별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByMntStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByMntStatus', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

export const getDashboardCountWorkItems = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countWorkItems', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 점검내역(파트별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByFllwActionTypeAndWorkingPart = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByFllwActionTypeAndWorkingPart', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수 점검내역(역사별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByFllwActionTypeAndStation = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByFllwActionTypeAndStation', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수 점검내역(역사의 후속조치별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByFllwActionType = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByFllwActionType', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수 등록현황
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByCategory = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByCategory', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}




/**
 * 유지보수내역(역사의 유지보수 조치유형별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByMntType = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByMntType', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수내역(파트별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByMntTypeAndWorkingPart = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByMntTypeAndWorkingPart', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
* 유지보수내역(역사별)
* @param {*} query 
* @returns 
*/
export const getDashboardCountGroupByMntTypeAndStation = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByMntTypeAndStation', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}
